import BodyText from '@lyra/core/components/BodyText'
import { MARKET_ICON_SIZE } from '@lyra/web/constants/layout'
import {
  formatInstrument,
  formatInstrumentWithSize,
  formatOptionExpiry,
  formatPerpLeverage,
  parseInstrumentName,
} from '@lyra/web/utils/instruments'
import React from 'react'
import { XStack, YStack } from 'tamagui'

import MarketIcon from './MarketIcon'

type Props = {
  instrumentName: string
  isLong: boolean
  size?: number
  leverage?: number
  icon?: React.ReactNode
}

export default function PositionCell({ instrumentName, isLong, leverage, size, icon }: Props) {
  const color = isLong ? 'green' : 'red'
  const instrument = parseInstrumentName(instrumentName)
  if (!instrument) {
    return null
  }
  return (
    <XStack alignItems="center" gap="$1">
      {icon ? icon : <MarketIcon size={MARKET_ICON_SIZE} marketId={instrument.marketId} />}
      <YStack>
        <BodyText>
          {size ? formatInstrumentWithSize(instrumentName, size) : formatInstrument(instrumentName)}
        </BodyText>
        <BodyText color="secondary">
          <BodyText color={color}>{isLong ? 'Long' : 'Short'}</BodyText>&nbsp;
          {instrument.type === 'option'
            ? formatOptionExpiry(instrumentName)
            : leverage
            ? formatPerpLeverage(leverage)
            : ''}
        </BodyText>
      </YStack>
    </XStack>
  )
}
